import React from "react";
import styles from "./Rules.module.css";
import GolfCourseAgreement from "../components/GolfCourseAgreement";
import Header from "../components/Header";

const Rules = () => {
  return (
    <>
      <Header />
      <div className={styles.wrapper}>
        <GolfCourseAgreement />
      </div>
    </>
  );
};

export default Rules;
